import React from 'react';
import { Edit, Trash } from 'lucide-react';
import { useB2BTranslation } from '../../B2BShared/hooks/useB2BTranslation';
import '../../B2BShared/B2BButtonStyles/B2BButtonStyles.css';

interface B2BParticipantActionsProps {
  isOwnProfile: boolean;
  currentUser: any;
  participant: any;
  onEdit: () => void;
  onDelete: () => void;
  isEditing?: boolean;
  onSave?: () => void;
  onCancel?: () => void;
}

const B2BParticipantActions: React.FC<B2BParticipantActionsProps> = ({
  isOwnProfile,
  currentUser,
  participant,
  onEdit,
  onDelete,
  isEditing = false,
  onSave,
  onCancel
}) => {
  const { t } = useB2BTranslation();
  
  // For own profile, edit is handled by header button, so only show for admin editing others
  const canEdit = !isOwnProfile && (currentUser?.role === 'admin');
  const canDelete = currentUser?.role === 'admin' && !isOwnProfile;

  if (isEditing) {
    return (
      <div className="card-actions">
        <button 
          type="button" 
          onClick={onCancel} 
          className="b2b-button b2b-button--secondary b2b-button--small"
        >
          {t('buttons.cancel')}
        </button>
        <button 
          type="button" 
          onClick={onSave} 
          className="b2b-button b2b-button--success b2b-button--small"
        >
          {t('buttons.save')}
        </button>
        {(isOwnProfile || currentUser?.role === 'admin') && (
          <button 
            type="button" 
            onClick={onDelete} 
            className="b2b-button b2b-button--danger b2b-button--small"
            title={t('buttons.deleteProfile')}
          >
            <Trash size={16} />
            {t('buttons.deleteProfile')}
          </button>
        )}
      </div>
    );
  }

  if (!canEdit && !canDelete) {
    return null;
  }

  return (
    <div className="card-actions">
      {canEdit && (
        <button 
          onClick={onEdit} 
          className="b2b-edit-button"
          title={t('buttons.editProfile')}
        >
          <Edit size={16} />
          {t('buttons.editProfile')}
        </button>
      )}
      {canDelete && (
        <button 
          onClick={onDelete} 
          className="b2b-button b2b-button--danger b2b-button--small"
          title={t('buttons.deleteProfile')}
        >
          <Trash size={16} />
          {t('common.delete')}
        </button>
      )}
    </div>
  );
};

export default B2BParticipantActions;
